module.exports = __webpack_public_path__ + "img/corsi_online_smartform.70d9dfc2.png";